/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * Form for creating a new unproxied MCP server
 */
export type CreateUnproxiedMcpServerForm = {
  /**
   * Optional description shown alongside the server.
   */
  description?: string | undefined;
  /**
   * Optional human-readable name for the unproxied MCP server. Empty values are stored as null.
   */
  name?: string | undefined;
  /**
   * The URL of the vendor's MCP server. Speakeasy never proxies tool calls through it; the only outbound requests Speakeasy ever makes to it are fetching a favicon and, on request, a live tool listing.
   */
  url: string;
};

/** @internal */
export type CreateUnproxiedMcpServerForm$Outbound = {
  description?: string | undefined;
  name?: string | undefined;
  url: string;
};

/** @internal */
export const CreateUnproxiedMcpServerForm$outboundSchema: z.ZodMiniType<
  CreateUnproxiedMcpServerForm$Outbound,
  CreateUnproxiedMcpServerForm
> = z.object({
  description: z.optional(z.string()),
  name: z.optional(z.string()),
  url: z.string(),
});

export function createUnproxiedMcpServerFormToJSON(
  createUnproxiedMcpServerForm: CreateUnproxiedMcpServerForm,
): string {
  return JSON.stringify(
    CreateUnproxiedMcpServerForm$outboundSchema.parse(
      createUnproxiedMcpServerForm,
    ),
  );
}
